import React, { useState, useEffect } from "react";
import { HelpPopup } from "../HelpPopup";
import { HelpButtonExpanded } from "../common/HelpButtonExpanded";
import { contact } from "../../configs/sysInfoConfig";
import { getRegistrationSysInfo } from "../../services/dashApiService";
import { ToggleIcon } from "../../components/common/ToggleIcon";
import { GenericButton } from "../../components/common/GenericButton";

export const Consent = ({
	onDataComplete,
	data,
	context,
	diseaseGroup,
	pid,
}) => {
	const [isShowingConsentHelp, setIsShowingConsentHelp] = useState(false);
	const [helpCode, setHelpCode] = useState();
	const [consentInfoChecked, setConsentInfoChecked] = useState(false);
	const [consentContactChecked, setConsentContactChecked] = useState(true);
	const [disableSaveButton, setDisableSaveButton] = useState(true);

	const handleSaveClick = () => {
		onDataComplete(context, {
			consentInfoChecked,
			consentContactChecked,
		});
	};

	const handleShowHelp = (helpCode) => {
		setHelpCode(helpCode);
		setIsShowingConsentHelp(true);
	};

	const onConsentInfoCheck = () => {
		setDisableSaveButton(!(!consentInfoChecked && consentContactChecked));
		setConsentInfoChecked(!consentInfoChecked);
	};

	const onConsentContactCheck = () => {
		setDisableSaveButton(!(consentInfoChecked && !consentContactChecked));
		setConsentContactChecked(!consentContactChecked);
	};

	const [sysInfo, setSysInfo] = useState(contact);
	useEffect(() => {
		if (pid && pid.diseaseGroupContact) {
			return setSysInfo(pid.diseaseGroupContact);
		}

		let didCancel = false;
		getRegistrationSysInfo(diseaseGroup)
			.then((result) => {
				if (result.success) {
					const data = result.data;
					if (!didCancel) {
						setSysInfo(data.contact);
					}
				} else {
					console.error(result.err);
				}
			})
			.catch((error) => {
				console.error("Error getting contact info: ", error);
			});

		return () => {
			didCancel = true;
		};
	}, [diseaseGroup, pid]);

	useEffect(() => {
		if (!data) {
			return;
		}

		setConsentInfoChecked(data.consentInfoChecked);
		//setConsentContactChecked(data.consentContactChecked);
		setConsentContactChecked(true);
		setDisableSaveButton(false);
	}, [data]);

	return (
		<div className={"text-sm lg:text-base"}>
			<h2 className={`text-2xl font-bold mb-2 text-center pt-2`}>
				Your Consent
			</h2>

			<div className={"flex-grow pt-2 sm:pt-4"}>
				<div className={"mb-2"}>
					<p className={"mb-3"}>Please read the following:</p>
					<div
						className={
							"w-full space-y-2 pb-4 border-b-2 border-white border-opacity-50"
						}
					>
						<HelpButtonExpanded
							onClick={() => handleShowHelp("Home.setup.consentINFO")}
							linkColorOverride="text-app-midblue"
							text={"Your Health Companion User Info"}
							suppressWidth={false}
							textSizeOverride="text-md"
							width={"w-9/12"}
						/>
						<HelpButtonExpanded
							onClick={() => handleShowHelp("Home.setup.TandCs")}
							linkColorOverride="text-app-midblue"
							text={"Terms and Conditions of use"}
							suppressWidth={false}
							textSizeOverride="text-md"
							width={"w-9/12"}
						/>
					</div>
				</div>

				<div className={"pt-2"}>
					<div className={"flex"}>
						<div className={"w-full inline text-left"}>
							Please confirm you have read the two documents above by ticking
							here:
						</div>

						<div className={`float-right pl-1 pb-1 flex justify-end`}>
							<ToggleIcon
								selection={
									consentInfoChecked ? "checkCircleOn" : "checkCircleOff"
								}
								classes="text-3xl"
								colourClasses={{
									checkCircleOn: "text-gray-600",
									checkCircleOff: "text-gray-600",
								}}
								onClick={onConsentInfoCheck}
							/>
						</div>
					</div>
				</div>

				<div className={"pt-6"}>
					<div className={"flex"}>
						<div className={"w-full inline text-left"}>
							Please note, we may occasionally contact you by email to provide
							support and to ask for your feedback.
						</div>

						<div className={"w-1/5 flex justify-end hidden"}>
							<ToggleIcon
								selection={
									consentContactChecked ? "checkCircleOn" : "checkCircleOff"
								}
								classes="text-3xl"
								colourClasses={{
									checkCircleOn: "text-gray-600",
									checkCircleOff: "text-gray-600",
								}}
								onClick={onConsentContactCheck}
							/>
						</div>
					</div>
				</div>

				<div className={"pt-6"}>
					<p className={"mb-2 sm:mb-4 "}>
						If you're at all stuck at any time, or wish to discuss consent
						further before proceeding, please call or email Your Health
						Companion support on:
					</p>

					<p className={"sm:mb-2"}>
						<span className={"w-16 inline-block font-bold "}>Email:</span>
						<a href={`mailto:${sysInfo.email}`}>{sysInfo.email}</a>
					</p>
					<p className={"sm:mb-4"}>
						<span className={"w-16 inline-block font-bold "}>Tel:</span>
						<a href={`tel:${sysInfo.telephone.replace(/\s+/g, "")}`}>
							{sysInfo.telephone}
						</a>
					</p>
				</div>

				<div className={"flex justify-center max-w-xs mx-auto pt-2"}>
					<div className={"w-1/2"}>
						<GenericButton
							text="Save"
							disabled={disableSaveButton}
							onClick={handleSaveClick}
							classes="active-button"
						/>
					</div>
				</div>
			</div>

			<HelpPopup
				show={isShowingConsentHelp}
				onClose={() => setIsShowingConsentHelp(false)}
				helpCode={helpCode}
				registration={true}
			/>
		</div>
	);
};
